var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67033 13.7747L7.31495 13.5423C7.01615 13.3469 0 8.7106 0 4.52976C0 1.55583 2.11327 0 4.20067 0C5.53514 0 6.785 0.622735 7.66996 1.6989C8.55194 0.624626 9.80373 0 11.1405 0C13.2279 0 15.3411 1.55595 15.3411 4.52976C15.3411 8.7106 8.32478 13.3471 8.0262 13.5426L7.67033 13.7747Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.f90f197158ed0cec08e745f172bbf721.svg";
export { ForwardRef as ReactComponent };